import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';

const parseAddress = (val) => {
  const empty = { via: '', cap: '', citta: '', prov: '' };
  if (!val || typeof val !== 'string') return empty;
  const idx = val.lastIndexOf(', ');
  const via = idx >= 0 ? val.slice(0, idx) : '';
  const rest = idx >= 0 ? val.slice(idx + 2) : val;
  const m = rest.match(/^(?:(\d{5})\s+)?(.*?)(?:\s*\(([A-Za-z]{2})\))?$/);
  return m ? { via, cap: m[1] || '', citta: m[2] || '', prov: m[3] || '' } : { ...empty, citta: rest };
};

const formatAddress = ({ via, cap, citta, prov }) => {
  const place = [cap.trim(), citta.trim()].filter(Boolean).join(' ') + (prov.trim() ? ` (${prov.trim().toUpperCase()})` : '');
  return [via.trim(), place.trim()].filter(Boolean).join(', ');
};

const Field = ({ label, testId, className = '', ...props }) => (
  <div className={className}>
    <label className="font-mono text-xs text-gray-400 block mb-1">{label}</label>
    <Input type="text" data-testid={testId} className="cyber-input w-full h-12 rounded-md px-3 text-sm" {...props} />
  </div>
);

export function AddressInput({ value, onChange, onCityChange, language }) {
  const it = language === 'it';
  const [fields, setFields] = useState(() => parseAddress(value));

  useEffect(() => { onCityChange?.(fields.citta); }, [fields.citta]);

  const update = (key) => (e) => {
    const updated = { ...fields, [key]: e.target.value };
    setFields(updated);
    onChange(formatAddress(updated));
  };

  return (
    <div className="space-y-3" data-testid="address-input">
      <Field label={it ? 'Via e numero civico' : 'Street and number'} testId="address-street"
        value={fields.via} onChange={update('via')} placeholder={it ? 'Es: Via Roma 12' : 'Ex: 12 Main Street'} autoFocus />
      <div className="grid grid-cols-6 gap-3">
        <Field className="col-span-3" label={it ? 'Città *' : 'City *'} testId="address-city"
          value={fields.citta} onChange={update('citta')} placeholder={it ? 'Es: Milano' : 'Ex: Milan'} />
        <Field className="col-span-2" label="CAP" testId="address-zip"
          value={fields.cap} onChange={update('cap')} placeholder="20100" maxLength={5} inputMode="numeric" />
        <Field className="col-span-1" label={it ? 'Prov.' : 'Prov.'} testId="address-province"
          value={fields.prov} onChange={(e) => update('prov')({ target: { value: e.target.value.toUpperCase() } })} placeholder="MI" maxLength={2} />
      </div>
      <div className="font-mono text-xs text-neon-cyan/60" data-testid="address-city-hint">
        {it ? 'La città è obbligatoria quando inserisci un indirizzo' : 'City is required when entering an address'}
      </div>
    </div>
  );
}
